<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">运营商信息</span>
        <el-button
          v-show="disabled"
          type="primary"
          plain
          class="title-btn"
          @click="cancel"
          >返回</el-button
        >
      </div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        style="width: 520px;"
      >
        <el-form-item label="方案名称" prop="projectName">
          <el-input
            v-model="form.projectName"
            placeholder="请输入方案名称"
            :disabled="disabled"
          />
        </el-form-item>
        <!-- <el-form-item label="承担方" prop="responsible">
          <el-radio-group
            v-model="form.responsible"
            :disabled="disabled"
            @change="changeResponsible"
          >
            <el-radio label="0">全平台直连</el-radio>
            <el-radio label="1">加盟直连</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="活动电站" prop="saveStation">
          <el-radio-group v-model="form.saveStation">
            <el-radio label="2">选择运营商</el-radio>
            <el-radio label="3">选择电站</el-radio>
            <!-- <el-radio label="2">互联互通</el-radio> -->
          </el-radio-group>

          <!-- <el-button v-show="!disabled" type="primary" plain @click="getDetail">确认</el-button> -->
        </el-form-item>
        <el-form-item prop="operator">
          <div class="border">
            <template v-if="form.saveStation == '2'">
              <el-input
                v-model="stationText1"
                placeholder="输入关键字进行过滤"
              />
              <el-tree
                ref="stationTree1"
                :data="stationData1"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handlestationChange1"
              />
            </template>
            <template v-if="form.saveStation == '3'">
              <el-input
                v-model="stationText2"
                placeholder="输入关键字进行过滤"
              />
              <el-tree
                ref="stationTree2"
                :data="stationData2"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handlestationChange2"
              />
            </template>
          </div>
        </el-form-item>
        <!-- <el-form-item label="选择电站" prop="discountSiteList">
          <div class="border">
            <STree v-model="form.discountSiteList" :data="discountSiteTree" style="width:300px;" :is-show-filter="!disabled" />
          </div>
        </el-form-item> -->
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">方案配置</span>
      </div>
      <div style="width: 700px;">
        <el-form
          ref="lastform"
          :model="lastform"
          :rules="lastrules"
          style="margin-top: 20px;"
          label-width="120px"
        >
          <el-form-item label="活动时间" prop="date">
            <el-date-picker
              v-model="lastform.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="disabled"
              @change="handleChange"
            />
          </el-form-item>
          <el-form-item label="活动周天" prop="checkList">
            <el-checkbox-group
              v-model="lastform.checkList"
              :disabled="disabled"
            >
              <el-checkbox
                v-for="item in weekOptions"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="活动介绍" prop="recommend">
            <el-input
              v-model="lastform.recommend"
              :disabled="disabled"
              type="textarea"
              :rows="4"
              placeholder="请输入广告内容"
            />
          </el-form-item>
          <el-form-item label="电费优惠" prop="electricModel">
            <el-select
              v-model="lastform.pricingModel.elecDiscount"
              :disabled="disabled"
              style="width: 200px;"
              placeholder="请选择优惠类型"
            >
              <el-option label="一口价" value="fixed" />
              <el-option label="折扣价" value="discount" />
            </el-select>
            <el-input
              v-model="lastform.pricingModel.elecValue"
              class="ml-20"
              :disabled="disabled"
              style="width: 150px;"
              ><template slot="append">{{
                lastform.pricingModel.elecDiscount === "fixed" ? "元" : "%"
              }}</template></el-input
            >
          </el-form-item>
          <el-form-item label="服务费优惠" prop="serviceModel">
            <el-select
              v-model="lastform.pricingModel.serviceDiscount"
              :disabled="disabled"
              style="width: 200px;"
              placeholder="请选择优惠类型"
            >
              <el-option label="一口价" value="fixed" />
              <el-option label="折扣价" value="discount" />
            </el-select>
            <el-input
              v-model="lastform.pricingModel.serviceValue"
              class="ml-20"
              :disabled="disabled"
              style="width: 150px;"
              ><template slot="append">{{
                lastform.pricingModel.serviceDiscount === "fixed" ? "元" : "%"
              }}</template></el-input
            >
          </el-form-item>

          <el-form-item label="活动用户" prop="userType">
            <el-radio-group
              v-model="lastform.userType"
              @change="partakeCancelTree()"
            >
              <el-radio
                v-for="(item, index) in userTypeItem"
                :key="index"
                :label="item.id"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="aUser">
            <!-- 选择企业 -->
            <div v-show="lastform.userType === '2'" class="border">
              <el-input
                v-model="filterMechanismText"
                placeholder="输入关键字进行过滤"
              />
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handleMechanismChange"
                :check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="lastform.userType === '3'" class="border">
              <el-input
                v-model="filterTagText"
                placeholder="输入关键字进行过滤"
              />
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handleTagChange"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div
      v-show="!disabled"
      class="btns"
      style="margin-top:30px; display: flex; align-items: center; justify-content:center;"
    >
      <el-button @click="cancel">{{ disabled ? "返回" : "取消" }}</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
const token = window.localStorage.getItem("token");
export default {
  name: "Xinzengyouhuifangan",
  components: {},
  data() {
    return {
      stationData1:[],
      stationData2:[],
      tempUserId: "",
      tempStationId: "",
      stationText1: "",
      stationText2: "",
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      treeDefaultProps: {
        children: "children",
        label: "name"
      },
      filterOperatorText: "", // 运营商过滤
      filterMechanismText: "", // 企业过滤
      filterTagText: "",
      userTypeItem: [
        {
          label: "全部用户",
          id: "1"
        },
        {
          label: "选择企业",
          id: "2"
        },
        {
          label: "选择标签",
          id: "3"
        }
      ],
      checkArr: [],
      id: "",
      disabled: false, // 新增还是详情
      filterText: "", // 筛选树的关键字
      defaultProps: {
        children: "children",
        label: "name"
      },
      weekOptions: [
        { label: "周日", value: "1" },
        { label: "周一", value: "2" },
        { label: "周二", value: "3" },
        { label: "周三", value: "4" },
        { label: "周四", value: "5" },
        { label: "周五", value: "6" },
        { label: "周六", value: "7" }
      ],
      form: {
        projectName: "",
        saveStation: "2",
        responsible: "0",
        operator: [],
        discountSiteList: [],
        userType: "1", // 可参与用户的单选字段
        mechanism: [], // 选择企业
        tag: [] // 选择标签
      },
      operatorTree: [],
      rules: {
        projectName: [{ required: true, message: "请输入方案名称" }],
        responsible: [{ required: true, message: "请选择承担方" }],
        operator: [
          { required: true, message: "请选择活动电站" }
        ],
        discountSiteList: [{ required: true, message: "请选择电站" }],
        saveStation: [{ required: true, message: "请选择活动电站" }],
      },
      lastform: {
        date: [],
        checkList: [],
        aUser:[],
        recommend: "",
        userType:'1',
        pricingModel: {
          elecDiscount: "",
          serviceDiscount: "",
          elecValue: "",
          serviceValue: "",
        },
        userID: [],
                mechanism: [], // 选择企业
        tag: [] // 选择标签
      },
      lastrules: {
        date: [{ required: true, message: "请选择时间" }],
        checkList: [{ required: true, message: "请选择活动周天" }],
        recommend: [{ required: true, message: "请输入活动介绍" }],
        electricModel: {
          required: true,
          validator: (rewardRules, value, cb) => {
            if (this.electriRule()) {
              return cb(new Error(this.electriRule()));
            }
            return cb();
          }
        },
        serviceModel: {
          required: true,
          trigger: "change",
          validator: (rewardRules, value, cb) => {
            if (this.serviceRule()) {
              return cb(new Error(this.serviceRule()));
            }
            return cb();
          }
        },
        userType: [{ required: true, message: "请选择活动用户" }],
        aUser: [{ required: true, message: "请选择活动用户" }],
      },
      discountSiteTree: [],
      userTree: []
    };
  },
  computed: {
    headers() {
      return {
        token: token
      };
    },
    // 电费优惠的动态校验
    electriRule() {
      return val => {
        let currentObj = {};
        currentObj = this.lastform.pricingModel;
        const elval = currentObj.elecValue;
        if (!currentObj.elecDiscount) {
          return "请选择优惠类型";
        }
        if (!elval && elval !== 0) {
          return "请输入优惠值";
        }
        if (currentObj.elecDiscount === "fixed") {
          if (!isNaN(currentObj.elecValue)) {
            if (
              String(elval).indexOf(".") > -1 &&
              String(elval).split(".")[1].length > 4
            ) {
              currentObj.elecValue = Number(elval).toFixed(4);
            }
          } else {
            return "请输入数字（支持4位小数）";
          }
        }
        if (currentObj.elecDiscount === "discount") {
          if (!isNaN(elval)) {
            if (String(elval).indexOf(".") > -1) {
              currentObj.elecValue = parseInt(elval);
            }
          } else {
            return "请输入整数";
          }
        }
      };
    },
    // 服务费的动态校验
    serviceRule() {
      return val => {
        let currentObj = {};
        currentObj = this.lastform.pricingModel;
        const sval = currentObj.serviceValue;
        if (!currentObj.serviceDiscount) {
          return "请选择优惠类型";
        }
        if (!sval && sval !== 0) {
          return "请输入优惠值";
        }
        if (currentObj.serviceDiscount === "fixed") {
          if (!isNaN(sval)) {
            if (
              String(sval).indexOf(".") > -1 &&
              String(sval).split(".")[1].length > 4
            ) {
              currentObj.serviceValue = Number(sval).toFixed(4);
            }
          } else {
            return "请输入数字（支持4位小数）";
          }
        }
        if (currentObj.serviceDiscount === "discount") {
          if (!isNaN(sval)) {
            if (String(sval).indexOf(".") > -1) {
              currentObj.serviceValue = parseInt(sval);
            }
          } else {
            return "请输入整数";
          }
        }
      };
    }
  },
  watch: {
    stationText1(val) {
      this.$refs.stationTree1.filter(val);
    },
    stationText2(val) {
      this.$refs.stationTree2.filter(val);
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    filterMechanismText(val) {
      this.$refs.treeMechanism.filter(val);
    },
    filterTagText(val) {
      this.$refs.treeTag.filter(val);
    }
  },
  beforeMount() {
    this.id = this.$route.query.data;
    if (this.$route.query.disabled === "true") {
      this.disabled = true;
    }
  },
  mounted() {
    this.getOperator();
    this.getUserTree();
    this.getTagTree();
    this.getMechanismTree();
  },

  methods: {
    handlestationChange1() {
      this.form.operator = this.$refs.stationTree1.getCheckedKeys();
    },

    handlestationChange2() {
      this.form.operator = this.$refs.stationTree2.getCheckedKeys();
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch("form/handle", {
        url: "/user/label/all",
        data: { orgType: "1,3", labelType: "0" },
        callback: resp => {
          this.tagTreeData = resp;
        }
      });
    },
    // 查询全部企业树的数据
    getMechanismTree() {
      this.$store.dispatch("form/handle", {
        url: "/setting/tree/org",
        data: { orgType: "1,3" },
        callback: resp => {
          this.mechanismTreeData = resp;
        }
      });
    },
    // 选择企业 赋值
    handleMechanismChange(data, checked, indeterminate) {
      this.lastform.mechanism = this.$refs.treeMechanism.getCheckedKeys();
      this.lastform.aUser=this.lastform.mechanism
    },
    // 选择标签 赋值
    handleTagChange(data, checked, indeterminate) {
      this.lastform.tag = this.$refs.treeTag.getCheckedKeys();
           this.lastform.aUser=this.lastform.tag
    },
    partakeCancelTree() {
      if(this.lastform.userType==1){
         this.lastform.aUser=[1,2,3]
         setTimeout(()=>{
         let arr=document.querySelectorAll('.el-form-item__error')
         if(arr.length>0){
          arr.forEach(item=>{
            console.log(item.innerText)
            if(item.innerText.indexOf('请选择活动用户')!=-1){
              item.style.display='none'
            }
          })
         }
         },0)
      }
      else{
        this.lastform.aUser=this.lastform.userType==2?this.lastform.mechanism:this.lastform.tag
        let arr=document.querySelectorAll('.el-form-item__error')
         if(arr.length>0){
          arr.forEach(item=>{
            console.log(item.innerText.indexOf('请选择活动用户')!=-1)
            if(item.innerText.indexOf('请选择活动用户')!=-1){
              item.style.display='block'
            }
          })
         }
      }
            this.$refs.treeMechanism.setCheckedKeys([]);
      this.$refs.treeTag.setCheckedKeys([]);
    },
    checkFn(e) {
      this.checkArr = e;
      this.lastform.userID = this.checkArr;
      console.log(this.lastform.userID, "userID");
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleCheckChange(data, checked, indeterminate) {
      this.lastform.userID = this.$refs.tree.getCheckedKeys();
    },
    changeResponsible(val) {
      console.log(val, 2222);
      this.form.responsible = val;
      this.form.operator = [];
      this.getOperator();
    },
    cancel() {
      this.$router.go(-1);
    },
    // save() {
    async save() {
            if(this.lastform.userType==1){
         this.lastform.aUser=[1,2,3]
      }
      else if(this.lastform.userType==2){
              this.lastform.aUser=this.lastform.mechanism
      }
            else if(this.lastform.userType==3){
              this.lastform.aUser=this.lastform.tag
      }

  
      try {
        // 必填校验
        await Promise.all([
          this.$refs.form.validate(),
          this.$refs.lastform.validate()
        ]);
      } catch (error) {
        return;
      }
      const weekList = this.lastform.checkList.join(",");
      const discountStartDay = this.lastform.date[0];
      const discountEndDay = this.lastform.date[1];
      const discountSite = this.form.discountSiteList.join(",");
      if (this.lastform.userType == 1) {
        this.tempUserId = "";
      } else if (this.lastform.userType == 2) {
        this.tempUserId = this.lastform.mechanism&&this.lastform.mechanism.length>0?this.lastform.mechanism.join(","):'';
      } else {
        this.tempUserId = this.lastform.tag&&this.lastform.tag.length>0?this.lastform.tag.join(","):'';
      }
      this.tempStationId=this.form.operator.join(',')
      const data = {
        projectName: this.form.projectName,
        responsible: this.form.responsible,
        operator: '',
        discountWeek: weekList,
        discountStartDay: discountStartDay,
        discountEndDay: discountEndDay,
        recommend: this.lastform.recommend,
        discountSite: this.tempStationId,
        userId: this.tempUserId,
        pricingModel: this.lastform.pricingModel,
        userType: this.lastform.userType,
        stationType:this.form.saveStation,
      };
      this.$store.dispatch("form/handle", {
        url: "/business/discountterm/put",
        data: data,
        method: "put",
        callback: resp => {
          this.$router.go(-1);
        }
      });
    },
    handleChange(value) {
      this.lastform.checkList = [];
      this.weekOptions = [
        { label: "周日", value: "1" },
        { label: "周一", value: "2" },
        { label: "周二", value: "3" },
        { label: "周三", value: "4" },
        { label: "周四", value: "5" },
        { label: "周五", value: "6" },
        { label: "周六", value: "7" }
      ];
      if (!value) return;
      const weekList = [];
      var date1 = new Date(Date.parse(value[0].replace(/-/g, "/")));
      var date2 = new Date(Date.parse(value[1].replace(/-/g, "/")));
      var iDays = parseInt(
        Math.abs(date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
      );
      console.log(iDays);
      if (iDays >= 7) {
        this.weekOptions = [
          { label: "周日", value: "1" },
          { label: "周一", value: "2" },
          { label: "周二", value: "3" },
          { label: "周三", value: "4" },
          { label: "周四", value: "5" },
          { label: "周五", value: "6" },
          { label: "周六", value: "7" }
        ];
      } else if (iDays <= 0) {
        const indexone = new Date(value[0]).getDay();
        this.weekOptions.forEach((item, index) => {
          if (indexone === index) {
            weekList.push(item);
          }
        });
        this.weekOptions = weekList;
      } else {
        const indexone = new Date(value[0]).getDay();
        const indextwo = new Date(value[1]).getDay();
        this.weekOptions.forEach((item, index) => {
          if (indexone < indextwo) {
            if (indexone <= index) {
              if (indextwo >= index) {
                weekList.push(item);
              }
            }
          } else if (indexone > indextwo) {
            if (indexone <= index) {
              weekList.push(item);
            } else if (indextwo >= index) {
              weekList.push(item);
            }
          }
        });
        this.weekOptions = weekList;
      }
    },

    formatData(_list) {
      _list;
    },

    // 获取活动用户
    getUserTree() {
      
      this.$store.dispatch("form/handle", {
        url: "/business/whitelist/getStationList",
        method: "get",
        callback: resp => {
          this.stationData2 = resp;
        }
      });
    },
    // 获取选择运营商树数据
    getOperator() {
      const data = {
        attr: this.form.responsible,
        orgTypes: "0,3",
        showOperatorName: true
      };
      this.$store.dispatch("form/handle", {
        url: "/business/discountterm/getResponsibleOrgTree",
        data: data,
        method: "get",
        callback: resp => {
          this.stationData1 = resp;
        }
      });
    },
    getDetail() {
      if (!this.form.operator || this.form.operator.length === 0) {
        this.$message("请选择运营商");
      } else {
        this.$store.dispatch("form/handle", {
          url: "/business/discountterm/getStation",
          data: {
            orgIds: this.form.operator.join(",")
          },
          method: "get",
          callback: resp => {
            this.discountSiteTree = resp;
          }
        });
      }
    }
  }
};
</script>

<style lang="less" src="" scoped>
.ml-20 {
  margin-left: 20px;
}
.border {
  border: 1px solid #eeeeee;
  padding: 20px;
  height: 300px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/discount/addDiscount.vue